
import { useState } from "react";
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../../assets/css/admin.min.css";

export function AuthenticationWrapper ({ children, variant = "basic", className = "" }) {
    return (
        <div className={`authentication-wrapper authentication-${variant} ${className}`}>
            <div className="authentication-inner">{children}</div>
        </div>
    );
}

const Admin = () => {
    const [showPassword, setShowPassword] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = new FormData();
        data.append("email", formData.email);
        data.append("password", formData.password);

        try {
            const response = await fetch("https://leapatinternational.com/admin/api/v1/login.php", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.status === "success") {
                toast.success("Login successful!");
                Cookies.set('isLoggedIn', 'true', { expires: 7 }); // Expires in 7 days
                Cookies.set('adminId', result.data.id, { expires: 7 }); // Store email in cookie
                navigate('/dashboard');
            } else {
                toast.error(result.message || "Login failed");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        }
    };
    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <AuthenticationWrapper variant="basic">
            <div className="card shadow-lg">
                <div className="card-body p-4">
                    {/* Logo */}
                    <div className="app-brand justify-content-center d-flex mb-4">
                        <a href="#" className="app-brand-link d-flex align-items-center gap-2 text-decoration-none p-3">
                            <img src="/assets/img/Leapat_header_logo.png" height={60} width={140} alt="Logo" />
                        </a>
                    </div>

                    {/* Welcome Message */}
                    <h4 className="mb-2 text-center">Welcome to Leapat! 👋</h4>

                    {/* Login Form */}
                    <form onSubmit={handleSubmit} className="mb-3">
                        {/* Email Field */}
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                                Email or Username
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                id="email"
                                name="email"
                                placeholder="Enter your email or username"
                                value={formData.email}
                                onChange={handleInputChange}
                                autoFocus
                                required
                            />
                        </div>

                        {/* Password Field */}
                        <div className="mb-3">
                            <div className="d-flex justify-content-between align-items-center">
                                <label className="form-label" htmlFor="password">
                                    Password
                                </label>
                                <a href="/forgotpassword" className="text-decoration-none small">
                                    Forgot Password?
                                </a>
                            </div>
                            <div className="d-flex input-group-merge">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="form-control"
                                    name="password"
                                    placeholder="············"
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                />
                                <span
                                    className="input-group-text cursor-pointer"
                                    onClick={togglePasswordVisibility}
                                    style={{ cursor: "pointer", width: "40px" }}
                                >
                                    {showPassword ? (
                                        // Eye Open (visible) SVG
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    ) : (
                                        // Eye Closed (hidden) SVG
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
                                            <line x1="1" y1="1" x2="23" y2="23" />
                                        </svg>
                                    )}
                                </span>
                            </div>
                        </div>

                        {/* Remember Me */}
                        <div className="mb-3">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="remember-me"
                                    name="rememberMe"
                                    checked={formData.rememberMe}
                                    onChange={handleInputChange}
                                />
                                <label className="form-check-label" htmlFor="remember-me">
                                    Remember Me
                                </label>
                            </div>
                        </div>

                        {/* Submit Button */}
                        <div className="mb-3">
                            <button className=" btn-signin d-grid w-100" type="submit">
                                Sign in
                            </button>
                        </div>
                    </form>

                    {/* Sign Up Link */}
                    {/* <p className="text-center">
                        <span>New on our platform? </span>
                        <a href="#" className="text-decoration-none">
                            <span>Create an account</span>
                        </a>
                    </p> */}
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />


        </AuthenticationWrapper>

    );
};

export default Admin;
